export const IS_SUBMITTING_THE_REVIEW = "IS_SUBMITTING_THE_REVIEW";
export const IS_ERROR_SUBMITTING_REVIEW = "IS_ERROR_SUBMITTING_REVIEW";
export const IS_REVIEW_SUBMITTED_SUCCESSFULLY =
  "IS_REVIEW_SUBMITTED_SUCCESSFULLY";
